import React from 'react';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';

/**
 * Stands in for the chart canvas before its nodes have arrived.
 *
 * Deliberately wears the canvas's own dashed boundary and tinted ground: the
 * chart replaces this element in place, so a large chart resolves without the
 * surrounding controls jumping, and the reader can see where the chart is going
 * to be while it loads rather than looking at an empty page.
 *
 * @param {string} [message] Shown instead of the spinner when the load failed.
 */
export default function OrganigramCanvasPlaceholder({ message }) {
    return (
        <div
            className="tw-flex tw-h-full tw-min-h-96 tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-border-2 tw-border-dashed tw-border-charcoal-25 tw-bg-charcoal-10"
            role="status"
            aria-live="polite"
        >
            {message ? <p className="tw-mb-0 tw-px-6 tw-text-center tw-text-sm tw-text-charcoal-75">{message}</p> : <LoadingSpinner />}
        </div>
    );
}
